<div class="dialog-content">
  <h2 matDialogTitle>Add New Industry</h2>
  <mat-dialog-content>
    <form [formGroup]="industryForm" (ngSubmit)="onSave()" novalidate class="fx-col fx-gap-20">
      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Industry Name</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <input matInput formControlName="name" placeholder="Enter industry name" required>
          <mat-error *ngIf="industryForm.get('name')!.hasError('required')">
            Industry name is required
          </mat-error>
          <mat-error *ngIf="industryForm.get('name')!.hasError('minlength')">
            Industry name must be at least 2 characters
          </mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Description (Optional)</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <input matInput formControlName="description" placeholder="Enter description" maxlength="500" required>
          <mat-hint align="end">{{industryForm.get('description')?.value?.length || 0}}/500</mat-hint>
          <mat-error *ngIf="industryForm.get('name')!.hasError('required')">
            Industry description is required
          </mat-error>
          <mat-error *ngIf="industryForm.get('name')!.hasError('minlength')">
            Industry description must be at least 10 characters
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="industryForm.invalid || isLoading">
      {{isLoading ? 'Saving...' : 'Save Industry'}}
    </button>
  </mat-dialog-actions>
</div>
